
<div class="page-header">
    <a routerLink="/activiteit-templates/overzicht" class="page-header__back">
        <i class="fa-regular fa-chevron-left"></i>
    </a>
    <h1 class="page-header__title">{{ "activity-templates.title" | translate }}</h1>
    <div class="page-header__actions"></div>
</div>

<app-activity-template-detail-form [activityTypes]="activityTypes$ | async" [activityTemplate]="activityTemplate$ | async" (submitted)="submit($event)" [errors]="errors$ | async" [loading]="loading$ | async"/>